import { render } from "./i18nText.vue?vue&type=template&id=1f83f2d4&scoped=true"
import script from "./i18nText.vue?vue&type=script&lang=js"
export * from "./i18nText.vue?vue&type=script&lang=js"

import "./i18nText.vue?vue&type=style&index=0&id=1f83f2d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f83f2d4"]])

export default __exports__